import React, { forwardRef } from 'react'
import { cn } from '../../utils'
import { InputProps } from '../../types'

export const Input = forwardRef<HTMLInputElement, InputProps>(({
  type = 'text',
  placeholder,
  value,
  defaultValue,
  disabled = false,
  required = false,
  error,
  label,
  name,
  id,
  className,
  children,
  'data-testid': dataTestId,
  onChange,
  onBlur,
  onFocus,
  ...props
}, ref) => {
  const inputId = id || name
  
  const baseInputClasses = 'block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-primary-500 focus:border-primary-500 transition-colors'
  
  const inputClasses = cn(
    baseInputClasses,
    error ? 'border-red-300 focus:border-red-500 focus:ring-red-500' : 'border-gray-300',
    disabled && 'bg-gray-50 text-gray-500 cursor-not-allowed',
    className
  )

  return (
    <div className="w-full">
      {label && (
        <label 
          htmlFor={inputId}
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      
      <input
        ref={ref}
        type={type}
        id={inputId}
        name={name}
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        disabled={disabled}
        required={required}
        className={inputClasses}
        data-testid={dataTestId}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        {...props}
      />
      
      {error && (
        <p className="mt-1 text-sm text-red-600" role="alert">
          {error}
        </p>
      )}
    </div>
  )
})

Input.displayName = 'Input'

export default Input